import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import {
  CLEAR_STATE_EXPULSION_ORDER,
  CLEAR_STATE_KNOWELEDGE_TEST_RECORD,
} from "../../../../redux/types";

import styles from "./toolBlockKnowledgeTest.module.css";

function ToolBlockKnowledgeTest({
  id,
  orderNum,
  showModal,
  addAccess = true,
  editAccess = true,
  viewAccess = true,
  extraAccess = true,
  extraBtnText,
  externalStyles,
  handleButtonExtra,
  additionalAccess = {},
  extraBtnDisabled = true,
  selectedRowData,
}) {
  const dispatch = useDispatch();
  const userId = Number(Cookies.get("userId"));

  const [addBtn, setAddBtn] = useState(true);
  const [viewBtn, setViewBtn] = useState(true);
  const [editBtn, setEditBtn] = useState(true);
  const [extraBtn, setExtraBtn] = useState(false);

  const navigate = useNavigate();
  const pathName = window.location.pathname.slice(1);
  const buttonsNames = {
    addBtnText: pathName.includes("listenerTracking")
      ? "Создать приказ"
      : pathName.includes("record-trained-users")
      ? "Добавить"
      : "Создать",
    viewBtnText: pathName.includes("knoweledge-test-record")
      ? "Просмотр протоколов"
      : "Просмотр",
    editBtnText: "Редактировать",
    extraBtnText: extraBtnText || "",
  };
  const handleButtonAdd = () => {
    switch (true) {
      case pathName.includes("applicationfortraining"): {
        navigate("/applicationfortraining/add", {
          state: { mode: "add" },
        });
        break;
      }
      case pathName.includes("listenerTracking"): {
        dispatch({ type: CLEAR_STATE_EXPULSION_ORDER });
        navigate("/listenerTracking/add", {
          state: { mode: "add", additionalAccess },
        });
        break;
      }
      case pathName.includes("record-trained-users"): {
        navigate("/record-trained-users/add", {
          state: { mode: "add" },
        });
        break;
      }
      case pathName.includes("knoweledge-test-record"): {
        dispatch({ type: CLEAR_STATE_KNOWELEDGE_TEST_RECORD });
        navigate("/knoweledge-test-record/add", {
          state: { mode: "add" },
        });
        break;
      }
      default:
        break;
    }
  };

  const handleButtonView = () => {
    switch (true) {
      case pathName.includes("applicationfortraining"): {
        navigate(`/applicationfortraining/view/${id}`, {
          state: { mode: "view", idStatement: id },
        });
        break;
      }
      case pathName.includes("listenerTracking"): {
        navigate(`/listenerTracking/view/`, {
          state: { mode: "view", idStatement: id, orderNum },
        });
        break;
      }
      case pathName.includes("record-trained-users"): {
        navigate(`/record-trained-users/view/`, {
          state: { mode: "view", userId: id },
        });
        break;
      }
      case pathName.includes("knoweledge-test-record"): {
        showModal(true);
        break;
      }
      default:
        break;
    }
  };
  const handleButtonEdit = () => {
    switch (true) {
      case pathName.includes("applicationfortraining"): {
        navigate(`/applicationfortraining/edit/${id}`, {
          state: { mode: "edit", idStatement: id },
        });
        break;
      }
      case pathName.includes("record-trained-users"): {
        navigate(`/record-trained-users/edit/${id}`, {
          state: { mode: "edit", userId: id },
        });
        break;
      }
      // case pathName.includes("knoweledge-test-record"):{
      //     navigate(`/knoweledge-test-record/edit/${id}`, {
      //         state: { mode:"edit",userId: id },
      //     });
      //     break;
      // }
      default:
        break;
    }
  };
  useEffect(() => {
    switch (true) {
      case pathName === "applicationfortraining":
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        setExtraBtn(true);
        break;
      case pathName === "listenerTracking":
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(false);
        break;
      case pathName === "knoweledge-test-record":
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(false);
        break;
      default:
        break;
    }
  }, [pathName]);

  return (
    <div className={styles["buttons-block"]}>
      {addBtn && addAccess && (
        <button
          id={`add`}
          title={buttonsNames.addBtnText}
          className={styles["add-btn"]}
          onClick={handleButtonAdd}
        >
          <span className={styles["plus-icon"]}></span>
          <p className={styles.buttons_text}>{buttonsNames.addBtnText}</p>
        </button>
      )}
      {viewBtn && viewAccess && (
        <>
          <button
            id={"view"}
            title={buttonsNames.viewBtnText}
            disabled={Boolean(!id)}
            className={styles["other-btn"]}
            onClick={handleButtonView}
          >
            <p className={styles.buttons_text}>{buttonsNames.viewBtnText}</p>
          </button>
        </>
      )}
      {editBtn && editAccess && (
        <button
          id={`edit`}
          title={buttonsNames.editBtnText}
          disabled={(() => {
            switch (true) {
              case window.location.pathname.includes("applicationfortraining"):
                if (selectedRowData?.inspector === userId) {
                  return false;
                } else return true;
              default:
                return Boolean(!id);
            }
          })()}
          className={styles["other-btn"]}
          onClick={handleButtonEdit}
        >
          <p className={styles.buttons_text}>{buttonsNames.editBtnText}</p>
        </button>
      )}
      {extraBtn && extraAccess && (
        <button
          id={`extra`}
          title={buttonsNames.extraBtnText}
          disabled={extraBtnDisabled}
          className={externalStyles ? externalStyles["extra-btn"] : ""}
          onClick={handleButtonExtra}
        >
          <p className={styles.buttons_text}>{buttonsNames.extraBtnText}</p>
        </button>
      )}
    </div>
  );
}
export default ToolBlockKnowledgeTest;
